import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EfkaEmployeeLine  {
    _originalTypeClassName = "zERP.BO.EfkaEmployeeLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EfkaEmployeeLine.translate = translateService;
}
this.PayableContributionAmount = null;
this.Content = null;
this.EfkaEmployeeLineKey = null;
this._key = this.EfkaEmployeeLineKey = 0; 
}

static translate: TranslateService;
_key: any;
PayableContributionAmount:any;
Content:any;
private _EfkaEmployeeLineKey:any;
get EfkaEmployeeLineKey(): any {
    return this._EfkaEmployeeLineKey;
  }
set EfkaEmployeeLineKey(value: any) {
    this._EfkaEmployeeLineKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EfkaEmployeeLineKey == null || $this.EfkaEmployeeLineKey == 0;
            }


}